import Alpine from 'alpinejs'

Alpine.data('registrationForm', (postUrl, projectId) => ({
    showForm: true,
    message: '',
    firstname: '',
    lastname: '',
    email: '',
    amount: '',
    isSubmitting: false,

    get amountNumeric() {
        return this.parseAmount(this.amount)
    },

    async onSubmit() {
        this.$dispatch('validate')
        const invalids = this.$root.querySelectorAll('[data-validation-valid="false"]')
        if (invalids.length > 0) return

        this.isSubmitting = true
        this.message = ''

        try {
            const response = await fetch(postUrl, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    project: projectId,
                    source: 'website',
                    firstname: this.firstname,
                    lastname: this.lastname,
                    email: this.email,
                    amount: this.parseAmount(this.amount),
                }),
            })

            if (response.ok) {
                this.showForm = false
            } else {
                const data = await response.json()
                this.message = data.message || 'Ein Fehler ist aufgetreten.'
            }
        } catch {
            this.message = 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.'
        } finally {
            this.isSubmitting = false
        }
    },

    parseAmount(value) {
        if (typeof value === 'number') return value
        return parseFloat(String(value).replace(/[^\d,]/g, '').replace(',', '.')) || 0
    },
}))
